import React from "react";

import { useAppDispatch, useAppSelector } from "store";
import {
    loadSuggestedNewLocationsSetup,
    selectIncludeExistingStoreLocations,
    selectIncludeOnlyRetailCentres,
    toggleIncludeExistingStoreLocations,
    toggleIncludeOnlyRetailCentres
} from "modules/customer/tools/location/suggestedNewLocations/suggestedNewLocationsSlice";

import { Box, FormControlLabel, Switch, Typography } from "@material-ui/core";
import { useTheme, withStyles } from "@material-ui/core/styles";

const StyledSwitch = withStyles(theme => ({
    switchBase: {
        "&$checked": {
            // @ts-ignore
            color: theme.palette.tertiary.main,
        },
        "&$checked + $track": {
            // @ts-ignore
            backgroundColor: theme.palette.tertiary.main
        },
        "&$disabled": {
            color: theme.palette.text.disabled
        },
        "&$disabled + $track": {
            backgroundColor: theme.palette.text.disabled
        }
    },
    checked: {},
    track: {},
    disabled: {}
}))(Switch);

const Title: React.FC = () => {
    const dispatch = useAppDispatch();
    const theme = useTheme();
    const includeExistingStoreLocations = useAppSelector(selectIncludeExistingStoreLocations);
    const includeOnlyRetailCentres = useAppSelector(selectIncludeOnlyRetailCentres);

    const onIncludeExistingStoreLocationsChange = () => {
        dispatch(toggleIncludeExistingStoreLocations());
        dispatch(loadSuggestedNewLocationsSetup());
    };

    const onIncludeOnlyRetailCentresChange = () => {
        dispatch(toggleIncludeOnlyRetailCentres());
        dispatch(loadSuggestedNewLocationsSetup());
    };

    const includeExistingStoreLocationsSwitch = (<StyledSwitch
        size="small"
        color="default"
        checked={includeExistingStoreLocations}
        onChange={onIncludeExistingStoreLocationsChange}
    />);

    const includeOnlyRetailCentresSwitch = (<StyledSwitch
        size="small"
        color="default"
        checked={includeOnlyRetailCentres}
        onChange={onIncludeOnlyRetailCentresChange}
    />);

    return (
        // @ts-ignore
        <Box position="sticky" top={0} bgcolor={theme.palette.background.paper} zIndex={theme.zIndex.drawer}>
            <Box paddingBottom={2}>
                <Typography variant="h5" component="div">
                    Suggested new locations
                </Typography>
            </Box>
            <Box paddingBottom={2}>
                <Typography variant="body1" component="div">
                    Based on your ideal customer and location targets, we've identified the areas with the strongest
                    alignment. This table highlights the most promising retail centres, ranked by overall fit, to help
                    prioritise your expansion plans.
                </Typography>
            </Box>
            <Box display="flex" alignItems="center" paddingTop={2} paddingBottom={2}>
                <FormControlLabel
                    control={includeOnlyRetailCentresSwitch}
                    label="Include only retail centres"
                />
                &nbsp;&nbsp;
                <FormControlLabel
                    control={includeExistingStoreLocationsSwitch}
                    label="Include existing store locations"
                />
            </Box>
        </Box>
    );
};

export default Title;
